export const categories = [
  {
    id: "scifi",
    name: "科幻",
    icon: "ri-planet-line",
    description: "星际航行、人工智能觉醒与未来科技想象，用十几分钟带你抵达明天。",
    count: 3,
  },
  {
    id: "suspense",
    name: "悬疑",
    icon: "ri-eye-line",
    description: "层层反转与心理博弈，每一集都让你猜不到结局。",
    count: 3,
  },
  {
    id: "drama",
    name: "剧情",
    icon: "ri-book-open-line",
    description: "普通人的高光时刻，用短剧的篇幅讲完一段完整的人生。",
    count: 3,
  },
  {
    id: "comedy",
    name: "喜剧",
    icon: "ri-emotion-laugh-line",
    description: "轻松解压的脑洞故事，笑点密集、节奏明快，适合碎片时间。",
    count: 2,
  },
  {
    id: "costume",
    name: "古装",
    icon: "ri-ancient-gate-line",
    description: "以古喻今的东方美学短剧，服化道细节与镜头语言同样考究。",
    count: 2,
  },
  {
    id: "urban",
    name: "都市",
    icon: "ri-building-2-line",
    description: "写字楼与便利店之间的都市速写，真实到让人心头一紧。",
    count: 1,
  },
  {
    id: "fantasy",
    name: "奇幻",
    icon: "ri-magic-line",
    description: "规则之外的想象力，现实与梦境在短剧中自由交汇。",
    count: 2,
  },
  {
    id: "animation",
    name: "动画",
    icon: "ri-movie-2-line",
    description: "AI 动画短片合集，风格化画面与声音实验的最佳舞台。",
    count: 1,
  },
  {
    id: "romance",
    name: "爱情",
    icon: "ri-heart-3-line",
    description: "克制又动人的情感短剧，用细节而不是台词说喜欢。",
    count: 1,
  },
];